import React, {useState, useEffect} from 'react'
import { Carousel } from "react-responsive-carousel";
import {isMobile} from 'react-device-detect';
import OwnYourSmile from './OwnYourSmile'
import LessVisits from './LessVisits';
import WorldClassProsthetics from './WorldClassProstheticsV2';
import GetBetterFunctional from './GetBetterFunctional';
import SingleVisit from './SingleVisit';

function MainBannerPat() {

  const slides = [
    {
      component: <OwnYourSmile key='1'/>,
      id: '1'
    },
    {
      component: <GetBetterFunctional key='2'/>,
      id: '2'
    },
    {
      component: <LessVisits key='3'/>,
      id: '3'
    },
    {
    component: <WorldClassProsthetics key='4'/>,
      id: '4'
    }, 
    {
      component: <SingleVisit key='5'/>,
        id: '5'
      }, 
  ]
  
  const indicatorHeight = (isMobile? 10 : 4)
  const indicatorWidth = (isMobile? 48 : 20)

  const indicatorStyle= {
    
    width: indicatorWidth,
    height: indicatorHeight,
    margin: '0 2px',
  };

  const [ activeSlide, setActiveSlide ] = useState(0);

  const [autoPlay, setAutoPlay] = useState(true);

  const nextSlide = () => {
    setActiveSlide(activeSlide+1);
  };

  useEffect(() => { 
    let t;
   
    function timerReset() {
       t= setTimeout(() => setActiveSlide(0), 10000)
    } 

    function timerNext() {
       t= setTimeout(nextSlide, 10000)
    }

    if(autoPlay){
      if(activeSlide===slides.length-1) {
        timerReset()
      } else {
        timerNext()
      }
    } 

    return() => {
      clearTimeout(t)
    }
    

  }, [activeSlide, autoPlay]) 

  return (
    <div className="relative h-screen">
      <Carousel swipeable={false} dynamicHeight={false} autoPlay={false} showIndicators={false} selectedItem={activeSlide} showStatus={false} showArrows={false} showThumbs={false}>
        {slides.map(slide => slide.component)}
       </Carousel>
       <ul className={`absolute bottom-8 inset-x-0 flex w-full flex-row ${isMobile? "justify-center gap-1" : "justify-center"}`} onMouseEnter={()=>setAutoPlay(false)} onMouseLeave={()=>setAutoPlay(true)}>
          {slides.map((slide, index)=> {
            return (
              <li key={slide.id} className={`${activeSlide === index ? 'opacity-100 bg-primary' : 'opacity-30 bg-gray-500'}`} style={indicatorStyle} role="button" onClick={() => setActiveSlide(index)}></li>
              )
          })}
        </ul>
    </div>
  )
}

export default MainBannerPat;
